import { BCMSValidate, Link, useWorkflowStep } from "@bcm-dev/bcms-vite";
import { FormContainer, FormRowView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { UIButton, UITextInput } from "components/ui";
import { getDefault, getWorkflowSteps } from "components/workflows/AdvancedAlertsAddEmailWorkflow";
import { SVGAsset } from "res";

import "./styles.css";

export default function AddEmailContent(props) {
    const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);
    const { email } = workflowStep.getStepState;

    const onChange = value => workflowStep.update([ "email" ], value);
    const onSubmit = evt => {
        const recipient = !BCMSValidate.isEmail(email)
            ? "tJefferson@sampleemail.com" : email;

        workflowStep.workflow.nextStep({ recipient });
    };

    return (
        <div className="add-email-content back-link-padding">
            <Link to="/advancedAlerts/manageRecipients" className="back-link">
                <span><SVGAsset id="LeftChevronIcon" /> Back</span>
            </Link>

            <p className="page-subtitle">Add Email</p>

            <FormContainer className="small-form-width">
                <FormRowView text="Email Address *">
                    <UITextInput value={ email } onChange={ onChange } />
                </FormRowView>

                <FormButtonRow>
                    <UIButton className="primary-button" text="Submit" onClick={ onSubmit } />
                </FormButtonRow>
            </FormContainer>
        </div>
    );
}